import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import translations from "../data/langData";
import { LanguageContext } from "../context/LanguageContext";

const Coaching = () => {
  const [videos, setVideos] = useState([]);
  const [sessiya, setSessiya] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);

  const [visibleSelect,setVisibleSelect] = useState(10)
  const { language } = useContext(LanguageContext);
  const t = translations[language];

  useEffect(() => {
    Promise.all([
      axios.get("https://www.turanozbahceci.com/api/sessiyaVideo.php"),
      axios.get("https://www.turanozbahceci.com/api/sessiyalar.php"),
    ]).then(([videoRes, sessiyaRes]) => {
      setVideos(videoRes.data);
      setSessiya(sessiyaRes.data);
    });
  }, []);

  const openModal = (videoLink) => {
    setSelectedVideo(videoLink); // Seçilen videoyu ayarla
    setShowModal(true); // Modal'ı aç
  };

  const closeModal = () => {
    setShowModal(false); // Modal'ı kapat
    setSelectedVideo(null); // Seçilen video linkini sıfırla
  };

  return (
    <>
      <div className="section section-padding-bottom ">
        <div className="container">
          <div className="d-flex justify-content-center align-items-center flex-column">
            <h5
              className="text-center mt-5 mb-3"
              style={{
                fontWeight: "normal",
                // maxWidth: "550px",
                width: "100%",
              }}
            >
              {t.coachingTitle}
            </h5>
            <p
              style={{
                maxWidth: "700px",
                width: "100%",
              }}
              className="text-center mb-5"
            >
              {t.coachingDesc}
            </p>
          </div>
          <div className="row  max-mb-n30">
            {/* Kurs Başlangıcı */}
            <div className="col-12">
              <div className="d-flex justify-content-between align-items-center my-2">
                <p>
                  {videos.length} nəticədən 1-{visibleSelect} arası göstərilir.
                </p>
                <select name="" id="projectsSelect" className="p-2" onChange={(e)=>setVisibleSelect(e.target.value)}>
                  <option value="" disabled selected>
                    {t.view}
                  </option>
                  <option value="10">10</option>
                  <option value="15">15</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
              </div>
            </div>
            {videos.slice(0,visibleSelect).map((item) => {
              const getVideoID = (url) => {
                const regex =
                  /(?:https?:\/\/(?:www\.)?youtube\.com\/(?:[^\/]+\/\S+\/|(?:v|e(?:mbed)?)\/|(?:.*[?&]v=))([^"&?/ ]{11}))/;
                const match = url.match(regex);
                return match ? match[1] : null;
              };

              const videoID = getVideoID(item.link);

              const thumbnailUrl = videoID
                ? `https://img.youtube.com/vi/${videoID}/maxresdefault.jpg`
                : null;
              return (
                <>
                  {thumbnailUrl && (
                    <div className="col-lg-4 col-md-4 col-sm-6 col-12 max-mb-30" key={item.id}>
                      <div className="course-2">
                        <button
                          className="video-thumbnail w-100"
                          onClick={() => openModal(item.link)}
                          style={{ border: "none", background: "transparent" }}
                        >
                          <img
                            src={item.img == "" ? thumbnailUrl : item.img}
                            alt=""
                            className="img-fluid"
                          />
                          <p>
                            {selectedVideo == null ? (
                              <i className="fa-solid fa-circle-play"></i>
                            ) : selectedVideo == item.link ? (
                              <i class="fa-solid fa-pause"></i>
                            ) : (
                              <i className="fa-solid fa-circle-play"></i>
                            )}
                          </p>
                        </button>
                      </div>
                    </div>
                  )}
                </>
              );
            })}
          </div>
        </div>
      </div>

      {/* YouTube Video Modalı */}
      {showModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content">
            <button className="close-button">X</button>
            <iframe
              width="100%"
              height="315"
              src={selectedVideo} // Seçilen video linki
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      )}
    </>
  );
};

export default Coaching;
